import { CanDeactivateFn } from "@angular/router";
import { QuestionnairePage } from "./questionnaire-page";

export const questionnaireLeave: CanDeactivateFn<QuestionnairePage> = (cmp) => {
  if (!cmp.store.isDirty()) {
    return true;
  }

  const message =
    "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?";

  return confirm(message);
};
